import _classCallCheck from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/createClass.js";
export var UDate = /*#__PURE__*/function () {
  // 构造函数
  function UDate() {
    _classCallCheck(this, UDate);
    // 实例化当前日期
    this.current = new Date();
    this.year = this.current.getFullYear();
    this.month = this.current.getMonth();
    this.date = this.current.getDate();
    this.day = this.current.getDay();
  }

  // 获取某月份的天数
  // @params { Object }  year month ...
  _createClass(UDate, [{
    key: "getDate",
    value: function getDate(params) {
      var year = params.year,
        month = params.month;
      var date = new Date(year || this.year, (month || this.month) + 1, 0);
      return date.getDate();
    }

    // 获取某一天是星期几
    // @params { Object }  year month  ||  new Date();
  }, {
    key: "getDay",
    value: function getDay(params) {
      var year = params.year,
        month = params.month,
        date = params.date;
      var Dates = year ? new Date(year, month, date) : params;
      return Dates.getDay();
    }
  }]);
  return UDate;
}();
export default new UDate();